import { toTenantDate } from '@utils/timeZone';
import { formatTime } from '@utils/i18n';

const formatConflictTime = (value?: string | null) => {
  if (!value) return undefined;
  const date = toTenantDate(value);
  return Number.isNaN(date.getTime()) ? undefined : formatTime(date);
};

export const formatConflictTimeRange = (startsAt?: string | null, endsAt?: string | null) =>
  [formatConflictTime(startsAt), formatConflictTime(endsAt)].filter(Boolean).join(' - ');
